import React, { ReactNode, memo } from "react";

import { Box } from "@UI/Components/Box/Box";
import { Heading } from "@UI/Components/Heading/Heading";
import { Text } from "@UI/Components/Text/Text";
import { VStack } from "@UI/Components/Stack/Stack";
import { BackLink } from "@Shared/Components/BackLink/BackLink";

const FORM_WIDTH = "350px";

export interface IAuthScreenLayoutProps {
  title: ReactNode;
  /** A sales line on the email screen, the address on the login screen. */
  subtitle?: ReactNode;
  onBack: () => void;
  /** The screen's own form. Absent on a screen that has none yet. */
  children?: ReactNode;
}

/** The body every screen of the auth step shares. */
export const AuthScreenLayout = memo(
  ({ title, subtitle, onBack, children }: IAuthScreenLayoutProps) => (
    <Box paddingY="16px">
      <VStack alignItems="stretch" spacing="16px">
        <Box>
          <BackLink onClick={onBack} />
        </Box>
        <Box>
          <Heading
            as="h1"
            fontFamily="heading"
            fontSize="3xl"
            lineHeight="1"
            color="gray.800"
          >
            {title}
          </Heading>
          {subtitle && (
            <Text color="gray.600" fontSize="md" lineHeight="150%">
              {subtitle}
            </Text>
          )}
        </Box>
        <Box maxWidth={{ base: "none", lg: FORM_WIDTH }}>{children}</Box>
      </VStack>
    </Box>
  )
);

AuthScreenLayout.displayName = "AuthScreenLayout";
